import { render } from "./FilterInput.vue?vue&type=template&id=4acdcf4d"
import script from "./FilterInput.vue?vue&type=script&lang=js"
export * from "./FilterInput.vue?vue&type=script&lang=js"
script.render = render

export default script